import { graphql } from '../gql';

export const submitVendorAvailability = graphql(`
  mutation SubmitVendorAvailability($input: SubmitVendorAvailabilityInput!) {
    submitVendorAvailability(input: $input) {
      success
      error {
        code
        message
      }
      submission {
        submittedAt
        submittedByEmail
        version
      }
    }
  }
`);
